export default {
  title: 'Settings',
  tabs: {
    details: 'Details',
    personalization: 'Customization',
    managers: 'Administrators',
    advanced: 'Advanced settings',
    translation: 'Translations',
    integration: 'Integration'
  },
  actions: {
    save: 'Save'
  },
  information: {
    title: 'Site Information',
    name: 'Name',
    description: 'Description',
    key: 'Secret',
    encryption: 'Encryption method',
    timezone: 'Time Zone'
  },
  contact: {
    title: 'Site Contact',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    phone: 'Phone'
  },
  media: {
    title: 'Default Medias',
    message: 'You can upload images to set the default medias for this site.',
    badges: 'Badges',
    users: 'Users',
    button: 'Upload image',
    buttonmessage: 'JPG/PNG (max: 3mb)'
  },
  authentication: {
    title: 'Authentication'
  },
  personalization: {
    title: 'Personalization'
  },
  languages: {
    title: 'Langues',
    en: 'English',
    fr: 'French',
    es: 'Spanish',
    ro: 'Romanian'
  },
  ip: {
    title: 'Trusted IPs'
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/settings.js